const isUserSupplier = (userPermissions) => {
  return userPermissions?.ust === 'external';
};

const permissionManager = {
  isUserSupplier,
};

export default permissionManager;
